import { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/use-api';
import { moduleClientFactory } from '../../../api-service/module-client-factory';
import { IUserLookup } from './interfaces';

interface InputParams {
  input: string;
  fetchMinimumInputLength: number;
  initialValue?: IUserLookup[];
  teamId?: string;
  includeInactiveUsers: boolean;
}

export const useFetch = (params: InputParams) => {
  const { input, fetchMinimumInputLength, initialValue, teamId, includeInactiveUsers } = params;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState<IUserLookup[]>(initialValue || []);

  const LookupsClient = moduleClientFactory.createLookupUserClient();
  const usersLookupApi = useApi((cancelToken, query: string) => LookupsClient.getUsersByLookupQuery({ query, includeInactiveUsers }), { users: [] });

  const usersByTeamLookupApi = useApi((cancelToken, query: string, team: string) => LookupsClient.getTeamUsersByLookupQuery({ query, teamId: team, includeInactiveUsers }), {
    users: [],
  });

  useEffect(() => {
    if (input.length >= fetchMinimumInputLength) {
      setLoading(true);

      if (teamId) {
        const searchByTeamId = async () => {
          try {
            const response = await usersByTeamLookupApi.invoke(input, teamId);
            setData(response.result.users || []);
          } catch (err: any) {
            setError(err);
          } finally {
            setLoading(false);
          }
        };
        searchByTeamId();
      } else {
        const search = async () => {
          try {
            const response = await usersLookupApi.invoke(input);
            setData(response.result.users || []);
          } catch (err: any) {
            setError(err);
          } finally {
            setLoading(false);
          }
        };
        search();
      }
    } else {
      setData(initialValue || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);

  return { loading, data, error };
};
